var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 25,
    viewBox: "0 0 78 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.3326 24.5837H28.0446L31.9745 0.431564H38.2632L34.3326 24.5837ZM22.7547 0.431564L16.7599 17.0436L16.0506 13.4664L16.0512 13.4677L13.9354 2.60619C13.9354 2.60619 13.6796 0.431564 10.9526 0.431564H1.04207L0.925781 0.840517C0.925781 0.840517 3.95642 1.47107 7.50327 3.60111L12.9663 24.5843H19.518L29.5221 0.431564H22.7547ZM72.2134 24.5837H77.9872L72.9531 0.430919H67.8984C65.5642 0.430919 64.9957 2.23083 64.9957 2.23083L55.6176 24.5837H62.1724L63.4833 20.9961H71.4769L72.2134 24.5837ZM65.2942 16.0403L68.5981 7.00194L70.4568 16.0403H65.2942ZM56.1092 6.2396L57.0066 1.05307C57.0066 1.05307 54.2376 0 51.351 0C48.2306 0 40.8203 1.36382 40.8203 7.99558C40.8203 14.2352 49.5175 14.3127 49.5175 17.5901C49.5175 20.8676 41.7164 20.2803 39.1419 18.2136L38.207 23.6366C38.207 23.6366 41.0148 25.0004 45.3046 25.0004C49.5957 25.0004 56.0691 22.7786 56.0691 16.7315C56.0691 10.4519 47.2938 9.8672 47.2938 7.13697C47.2944 4.4061 53.4184 4.7569 56.1092 6.2396Z",
    fill: "#2566AF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.55589a4751df130cc306adf5f953e30e.svg";
export { ForwardRef as ReactComponent };